export const nameof = (descriptor: object) => {
    if(typeof descriptor !== 'object')
        throw Error('descriptor has to be an object');
    return Object.getOwnPropertyNames(descriptor)[0];
}


// WEBPACK FOOTER //
// ./src/app/utils/nameof.ts